// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2K8GG","list":"styles_list__Lkn_b"};